export default __webpack_public_path__ + "static/media/bg-about10.0001afa3.jpg";